import React, { useEffect, useState } from 'react';
import HeaderStyleThree from '../../components/Layout/Header/HeaderStyleThree';
import Footer from '../../components/Layout/Footer';
import BackToTop from '../../components/elements/BackToTop';
import ScheduleHero from './ScheduleHero';
import ScheduleMain from './ScheduleMain';
import { supabase } from '../../supabaseClient';
import defaultScheduleData from '../../data/schedule.json';

const SchedulePage = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [scheduleData, setScheduleData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const handleScroll = () => setIsVisible(window.scrollY > 300);
        document.addEventListener('scroll', handleScroll);
        
        const fetchScheduleData = async () => {
            try {
                const { data, error } = await supabase
                    .from('schedule_page_content')
                    .select('*')
                    .eq('page_name', 'schedule-page')
                    .single();
                    
                if (error || !data) {
                    setScheduleData(defaultScheduleData);
                } else {
                    setScheduleData(data.data);
                }
            } catch (err) {
                setScheduleData(defaultScheduleData);
            }
            setLoading(false);
        };
        
        fetchScheduleData();

        return () => document.removeEventListener('scroll', handleScroll);
    }, []);

    if (loading) {
        return (
            <div className="homestyle2" style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'var(--eventflow-black)' }}>
                <div className="spinner-border text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="homestyle2">
            <HeaderStyleThree />
            <ScheduleHero scheduleData={scheduleData} />
            <ScheduleMain scheduleData={scheduleData} />
            <BackToTop scroll={isVisible} />
            <Footer />
        </div>
    );
};
export default SchedulePage;
